import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import packageJson from '../../package.json';
import { getBrandName } from './brand';

const GameRun = () => {
  const appName = packageJson.name;
  const version = packageJson.version;
  const location = useLocation();
  const navigate = useNavigate();
  const brandName = getBrandName();
  const { iframeUrl } = location.state || {};
  const username = localStorage.getItem('username');

  const [loading, setLoading] = useState(true);

  const handleClose = () => {
    navigate('/');
  };

  return (
    <div className="cdk-overlay-container">
      <div
        className="cdk-global-overlay-wrapper"
        dir="ltr"
        style={{
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column"
        }}
      >

        {/* Header */}
        <div
          style={{
            position: "sticky",
            top: 0,
            width: "100%",
            background: "#0f0f0f",
            zIndex: 9999,
            padding: "2px 15px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid rgba(255,255,255,0.1)"
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "#00d4c3", fontWeight: "600", fontSize: "14px" }}>
              {getBrandName()}
              <span style={{ color: "#576775", marginLeft: 5 }}>
                - v.{version}
              </span>
            </span>
            <span style={{ color: "#ffffff", fontSize: "14px", fontWeight: "700" }}>
              {username}
            </span>
          </div>

          <div
            onClick={handleClose}
            style={{
              fontSize: "22px",
              color: "#ffffff",
              cursor: "pointer",
              fontWeight: "bold"
            }}
          >
            <img
              width={20}
              alt="close"
              src="https://img.b112j.com/bj/h5/assets/v3/images/icon-set/utility-type/icon-close.svg?v=1770792598866"
            />
          </div>
        </div>

        {/* Iframe Section */}
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            background: "#000"
          }}
        >
          {/* 🔥 Loader */}
          {loading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                background: "#6f7b84",
                paddingBottom: "150px",
                zIndex: 999
              }}
            >
              <div className="dot-loaderss">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          )}


          <iframe
            name="myiFrame"
            width="100%"
            height="100%"
            allowFullScreen
            style={{
              border: "none",
              display: "block"
            }}
            scrolling="yes"
            src={iframeUrl}
            title="Game"
            onLoad={() => setLoading(false)}
          />
        </div>
      </div>
    </div>
  );
};

export default GameRun;
